import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { toCamelCase } from "utils/Utils";

const ReferenceReview = ({ classes, referenceDetails }) => {
    console.log(referenceDetails,"fkafjka")
  const itemView = (label, value) => {
    return (
      <Grid item xs={12} sm={6} md={3} className={classes.fieldContainer}>
        <p style={{ marginBottom: 0 }}>
          <b>{label}</b>
        </p>
        <label>{value}</label>
      </Grid>
    );
  };

  return (
    <Grid container spacing={2}>
      {/* Title */}
      <Grid item xs={12} className={classes.inputFieldContainer}>
        <h2 className={classes.header} style={{ fontSize: "1.5rem" }}>
          Reference Details
        </h2>
      </Grid>

      {/* Reference Details List */}
      <Grid item xs={12} container spacing={2} alignItems="center">
        <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
          <Grid container className={classes.inputFieldContainer} spacing={2}>
            {referenceDetails?.map((item, index) => (
              <React.Fragment key={index}>
                {itemView("Name", toCamelCase(item?.referalName) || "NA")}
                {itemView("Relation", toCamelCase(item?.referalRelation) || "NA")}
                {itemView("Mobile Number", item?.phoneNumber || "NA")}
              </React.Fragment>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

ReferenceReview.propTypes = {
  classes: PropTypes.object,
  referenceDetails: PropTypes.arrayOf(
    PropTypes.shape({
      referalName: PropTypes.string,
      referalRelation: PropTypes.string,
      phoneNumber: PropTypes.string,
    })
  ),
};

export default ReferenceReview;
